import { debounce, isEmpty, omit } from 'lodash';

type SetRequestParamsCallback = (
    updater: (prev: Record<string, any> | undefined) => Record<string, any> | undefined
) => void;

class LabelsService {
    createDebouncedSearch(
        setRequestParams: SetRequestParamsCallback,
        debounceDelay: number = 300
    ): (searchValue: string) => void {
        return debounce((searchValue: string) => {
            if (searchValue?.trim?.()) {
                setRequestParams((prev) => ({ ...prev, label: searchValue }));
            } else {
                setRequestParams((prev) => {
                    const rest = omit(prev, 'label');
                    return isEmpty(rest) ? undefined : rest;
                });
            }
        }, debounceDelay);
    }
}

const labelsService = new LabelsService();

export { labelsService as LabelsService };
